
export const KARMA_POINTS = {
  CREATE_POST: 5,
  RECEIVE_LIKE: 5,
  MAKE_COMMENT: 5,
  RECEIVE_REACTION: 5
};

export const ACHIEVEMENTS = {
  FIRST_POST: {
    id: 'first_post',
    title: 'First Steps',
    description: 'Created your first post',
    icon: '🌟',
    requirement: 1
  },
  POPULAR_POST: {
    id: 'popular_post',
    title: 'Rising Star',
    description: 'Received 10 likes on a post',
    icon: '⭐',
    requirement: 10
  },
  ACTIVE_COMMENTER: {
    id: 'active_commenter',
    title: 'Conversation Starter',
    description: 'Made 5 comments',
    icon: '💭',
    requirement: 5
  },
  KARMA_MILESTONE: {
    id: 'karma_milestone',
    title: 'Karma Collector',
    description: 'Reached 100 karma points',
    icon: '🏆',
    requirement: 100
  }
};
